import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { Pen, CodeXml, FolderCode, Database } from "lucide-react";
import { Link } from "react-router-dom";
import "./LiveTesting.scss";

const services = [
  {
    title: "Code Conversion",
    description: "Language transformation or translation",
    icon: CodeXml,
    link: "/code-conversion",
    style: "primary",
  },
  {
    title: "Architecture Based Conversion",
    description: "System redesign for different architecture",
    icon: FolderCode,
    link: "/architecture-based-conversion",
    style: "secondary",
  },
  {
    title: "Database Conversion",
    description: "Data migration across database systems",
    icon: Database,
    link: "/database-conversion",
    style: "neutral",
  },
  {
    title: "Version Upgrade",
    description: "Language/Framework Version upgrade",
    icon: Pen,
    link: "/version-upgrade",
    style: "quaternary",
  },
];

function LiveTesting() {
  return (
    <div className="page-wrapper live-testing-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">What service are you looking for?</h2>
              <div className="service-wrapper">
                <Row>
                  {services.map((service, index) => (
                    <Col md={4} className="mb-5" key={index}>
                      <Link
                        to={service.link}
                        style={{ textDecoration: "none" }}
                        className="w-100"
                      >
                        <Card className="service-list text-center">
                          <Card.Body>
                            <div className={`icon-container ${service.style}`}>
                              <service.icon size={32} color="#ffffff" strokeWidth={1} absoluteStrokeWidth />
                            </div>
                            <Card.Title>{service.title}</Card.Title>
                            <Card.Body className="card-body-div">
                              {service.description}
                            </Card.Body>
                          </Card.Body>
                        </Card>
                      </Link>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LiveTesting;
